import React from 'react';
import HeroSection from '../home/HeroSection';
import HighlightsSection from '../home/HighlightsSection';
import BentoGrid from '../home/BentoGrid';
import ComparisonSection from '../home/ComparisonSection';
import SpecificationsSection from '../home/SpecificationsSection';
import CallToAction from '../home/CallToAction';
import './Home.css';

/**
 * PeaceMobiles Flagship Showcase Home Page
 * Minimalist, elegant, high visual hierarchy:
 * - High-contrast 3-model hero switcher
 * - Key innovation highlights carousel
 * - Bento-box feature matrix
 * - Comprehensive 3-model side-by-side comparison
 * - Complete technical specifications
 * - Authorized network & support CTA
 */
const Home = () => {
  return (
    <div className="apple-home-root">
      {/* 1. Full Viewport Hero Section with Prominent 3-Model Switcher */}
      <HeroSection />

      {/* 2. Key Innovation Highlights Carousel */}
      <HighlightsSection />

      {/* 3. Bento-Box Feature Matrix */}
      <BentoGrid />

      {/* 4. Comprehensive 3-Model Comparison */}
      <ComparisonSection />

      {/* 5. Technical Specifications Breakdown */}
      <SpecificationsSection />

      {/* 6. Authorized Dealer & Support Call to Action */}
      <CallToAction />
    </div>
  );
};

export default Home;